











import { defineComponent, onMounted } from '@vue/composition-api';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
export default defineComponent({
  setup(props, context) {
    // TODO: 等移动端协议出来再改
    const appLink = 'cofile://com.tencent.cofile/main?path=%2fcommon%2fscan&business=login';
    onMounted(() => {
      if (!window) return;
      dispatchRouter(appLink, 'location');
    });
    return {
      appLink,
    };
  },
});
